module.exports = __webpack_public_path__ + "img/architecture_home.aa631c5b.jpg";